import { Pipe, PipeTransform } from '@angular/core';
import { PolicyStatus, Role, RoleType } from '@lockton-apps/shared/interfaces';
import { get } from 'lodash';

interface PolicyStatusMeta {
  icon: string;
  label: string;
}

export const POLICY_STATUS_CONTACT_META = {
  [PolicyStatus.Active]: {
    icon: 'tick',
    label: $localize`Active`,
  },
  [PolicyStatus.Inactive]: {
    icon: 'more',
    label: $localize`Not bound`,
  },
  [PolicyStatus.Mta]: {
    icon: 'edit',
    label: $localize`Adjustments`,
  },
  [PolicyStatus.Pending]: {
    icon: 'health_evaluation_thin',
    label: $localize`Health evaluation required`,
  },
  [PolicyStatus.Expired]: {
    icon: 'exclaim',
    label: $localize`Expired`,
  },
  [PolicyStatus.Cancelled]: {
    icon: 'delete',
    label: $localize`Cancelled`,
  },
  [PolicyStatus.Defunct]: {
    icon: 'delete',
    label: $localize`Defunct`,
  },
  [PolicyStatus.Initialized]: {
    icon: 'help',
    label: $localize`Initialized`,
  },
};

export const POLICY_STATUS_BROKER_META = {
  [PolicyStatus.Active]: {
    icon: 'tick',
    label: $localize`Active`,
  },
  [PolicyStatus.Inactive]: {
    icon: 'more',
    label: $localize`Not bound`,
  },
  [PolicyStatus.Mta]: {
    icon: 'edit',
    label: $localize`Adjustments`,
  },
  [PolicyStatus.Pending]: {
    icon: 'more',
    label: $localize`Pending`,
  },
  [PolicyStatus.Expired]: {
    icon: 'exclaim',
    label: $localize`Expired`,
  },
  [PolicyStatus.Cancelled]: {
    icon: 'delete',
    label: $localize`Cancelled`,
  },
  [PolicyStatus.Defunct]: {
    icon: 'delete',
    label: 'Defunct',
  },
  [PolicyStatus.Initialized]: {
    icon: 'help',
    label: 'Initialized',
  },
};

@Pipe({
  name: 'policyStatusMeta',
  standalone: true,
})
export class PolicyStatusMetaPipe implements PipeTransform {
  transform(
    value: PolicyStatus,
    userRole: RoleType = Role.Contact
  ): PolicyStatusMeta {
    const meta =
      userRole === Role.Contact
        ? POLICY_STATUS_CONTACT_META
        : POLICY_STATUS_BROKER_META;

    return get(meta, value, {
      icon: 'help',
      label: 'unknown',
    });
  }
}
